/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TitleModel } from '../../models/title-model';

export interface TitleIdGet$Params {
  id: string;
}

export function titleIdGet(http: HttpClient, rootUrl: string, params: TitleIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<TitleModel>> {
  const rb = new RequestBuilder(rootUrl, titleIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<TitleModel>;
    })
  );
}

titleIdGet.PATH = '/Title/{id}';
